import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Feed from "@/pages/Feed";
import CreatePost from "@/pages/CreatePost";
import CaiDashboard from "@/pages/CaiDashboard";
import PainPool from "@/pages/PainPool";
import AltFinancier from "@/pages/AltFinancier";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Playground from "@/pages/Playground";
import Wallet from "@/pages/Wallet";
import Settings from "@/pages/Settings";

function AppRouter() {
  const location = useLocation();
  // Intercept Emergent OAuth callback (fragment contains session_id)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/feed" element={<Feed />} />
      <Route path="/create" element={<CreatePost />} />
      <Route path="/dashboard" element={<CaiDashboard />} />
      <Route path="/pain" element={<PainPool />} />
      <Route path="/alt-financier" element={<AltFinancier />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/wallet" element={<Wallet />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
